import { date, showAlert } from '../../../lib/helpers';
import { editedItem, headers, search } from './attributes';
import { dataListPaymentType, dataListSettlementStatus, dataListTrxReportStatus, dataListTrxType, dataQrMethod, dataQrType, productIndicatorOptions, sof } from '../../../store/params';

export default {
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonSwitchCh: true,
      buttonDotsExt: [
        {
          link: 'exportExcelParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    isFirstLoad: true,
    rangeDateDialog: false,
    options: {},
    show: false,
    dialog: false,
    expanded: [],
    headers,
    filter: {
      trx_datetime: [],
    },
    search,
    editedItem,
    selectedRow: '',
    searchAcquirer: '',
    searchIssuer: '',
    listTrxReportStatus: dataListTrxReportStatus,
    listPaymentType: dataListPaymentType,
    listTrxType: dataListTrxType,
    qrMethod: dataQrMethod,
    qrType: dataQrType,
    dateFormatted: '',
    dateMenu: false,
    listSettlementStatus: dataListSettlementStatus,
    listSof: sof,
    filterValue: { trx_datetime: [], ac_id: '', payment_type: '', rrn: '', mid: '', bill_number: '', status: '', product_indicator: '' },
    submittedFilter: { trx_datetime: [], ac_id: '', payment_type: '', rrn: '', mid: '', bill_number: '', status: '', product_indicator: '' },
    searchAggregator: '',
    searchMerchant: '',
    loadingMerchant: false,
    loadingAggregator: false,
    acId: null,
    mId: null,
    expandedData: {},
  }),

  computed: {

    filterConfig(){
      const base = [
        { key: 'trx_datetime', type: 'daterange', required: true, props: { label: 'Transaction Date', includeToday: true, limitRangeTo30Days: true } },
        {
          key: 'ac_id',
          type: 'autocomplete',
          props: {
            label: 'Aggregator Name',
            items: this.aggregatorList,
            loading: this.loadingAggregator,
            itemText: 'merchant_name',
            itemValue: 'ac_id',
            search: this.searchAggregator,
          }
        },
        {
          key: 'mid',
          type: 'textfield',
          props: {
            label: 'MID',
          }
        },
        { key: 'payment_type', type: 'select', props: { label: 'Payment Type', items: dataListPaymentType } },
        { key: 'rrn', type: 'textfield', props: { label: 'Reff ID' } },
        { key: 'bill_number', type: 'textfield', props: { label: 'Bill Number' } },
        { key: 'product_indicator', type: 'select', props: { label: 'QR Method', items: productIndicatorOptions } },
        { key: 'status', type: 'select', props: { label: 'Status', items: dataListTrxReportStatus } },
      ];

      return base;
    },
    aggregatorList() {
      return this.$store.state.report.aggregatorList;
    },
    merchantList() {
      return this.$store.state.report.merchantList;
    },
    allData() {
      return this.$store.state.report.nfcTransaction.allData;
    },
    detailData() {
      return this.$store.state.report.nfcTransaction.item;
    },
    allCategory() {
      return this.$store.state.report.nfcTransaction.allCategory;
    },
    totalData() {
      return this.$store.state.report.nfcTransaction.totalData;
    },
    totalPage() {
      return this.$store.state.report.nfcTransaction.totalPage;
    },
    loading() {
      return this.$store.state.report.nfcTransaction.loading;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('report/nfcTransaction/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    searchAggregator(val) {
      if (val && val.length >= 3) {
        this.acId = val;
        this.getAggregator();
      } else {
        this.acId = '';
        this.$store.commit('report/clearAggregator');
      }
    },
    searchMerchant(val) {
      if (val && val.length >= 3) {
        this.mId = val;
        this.getMerchant();
      } else {
        this.mId = '';
        this.$store.commit('report/clearMerchant');
      }
    },

    'filterValue.ac_id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$store.commit('report/clearMerchant');
          this.filterValue.mid = '';
        
          if (newVal) {
            this.getMerchant();
          }
        }
      }
    },
  },

  methods: {
    handleFilterSearchInput(payload) {
      const { key, value } = payload || {};
      if (key === 'ac_id') {
        this.searchAggregator = value;
      }
      else if (key === 'mid') {
        this.searchMerchant = value;
      }
    },
    handleFilterValueChange(payload) {
      const { key, value } = payload || {};
      
      if (key === 'ac_id') {
        this.$set(this.filterValue, 'ac_id', value);
        this.$set(this.filterValue, 'mid', '');
        this.$store.commit('report/clearMerchant');
        if (value) {
          this.getMerchant();
        }
      } else if (key === 'mid') {
        this.$set(this.filterValue, 'mid', value);
      } else if (key === 'payment_type') {
        this.$set(this.filterValue, 'payment_type', value);
        this.$set(this.search, 'payment_type', value);
      } else {
        this.$set(this.filterValue, key, value);
        this.$set(this.search, key, value);
      }
    },
    onExpandRow(itemId) {
      this.$store
        .dispatch('report/nfcTransaction/getDetail', {
          itemId,
          date,
        })
        .then(() => {
          if (this.detailData != null) {
            this.$set(this.expandedData, itemId, { ...this.detailData });
          }
        });
    },
    getMerchant() {
      this.loadingMerchant = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      const selectedAcId = this.filterValue.ac_id;
  
      this.$store
        .dispatch('report/getMerchant', {
          date,
          sortBy: 'ID',
          search: { ac_id: selectedAcId, mid: this.mId },
          source: 'aggregator',
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },
    getAggregator() {
      this.loadingAggregator = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      this.$store
        .dispatch('report/getAggregator', {
          date,
          sortBy: 'ID',
          search: { name: this.acId },
        })
        .then(() => {
          this.loadingAggregator = false;
        });
    },
    getTooltipMethod(item) {
      const descriptions = {
        mpm: 'Merchant Presented Mode',
        cpm: 'Customer Presented Mode',
        qristap: 'QRIS NFC',
        'qris tap - single': 'Single Tap Mode',
        'qris tap - tap out': 'Tap Out Finalization Mode',
        'qris tap - tap out without completion': 'Tap Out Without Completion Mode'
      };
      const jenis = item.qr_method?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    getTooltipPayement(item) {
      const descriptions = {
        'on us': 'Transaksi pembayaran dalam jaringan BNI',
        'off us': 'Transaksi pembayaran diluar jaringan BNI'
      };

      const jenis = item.payment_type?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    updateSearchValues(newSearch) {
      const fields = ['trx_datetime', 'ac_id', 'rrn', 'mid', 'bill_number', 'status', 'product_indicator', 'payment_type'];
      fields.forEach(field => {
        const value = field === 'trx_datetime' ? (newSearch[field] || []) : (newSearch[field] || '');
        this.$set(this.search, field, value);
        this.$set(this.filterValue, field, value);
      });
    },
    updateSearch(newSearch) {
      this.updateSearchValues(newSearch);
      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.updateSearchValues(newSearch);
      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      this.options.page = 1;
      this.getData(); 
    },
    getData() {
      if (this.search.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('report/nfcTransaction/clearData');
      } else {
        const { page, itemsPerPage } = this.options;
        this.$store
          .dispatch('report/nfcTransaction/getData', {
            date,
            page,
            itemsPerPage,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },
    clearSearch() {
      const fields = ['trx_datetime', 'ac_id', 'payment_type', 'rrn', 'mid', 'status', 'bill_number', 'product_indicator'];
      fields.forEach(field => {
        const value = field === 'trx_datetime' ? [] : '';
        this.$set(this.search, field, value);
        this.$set(this.filterValue, field, value);
      });
      
      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      
      this.$nextTick(() => {
        this.$store.commit('report/nfcTransaction/clearData');
        this.$store.commit('report/clearAggregator');
        this.$store.commit('report/clearMerchant');
      });
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('report/nfcTransaction/getDetail', {
          itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    exportExcel() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('report/nfcTransaction/clearData');
      } else {
        const { page, itemsPerPage } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy: ['trx_datetime'],
          sortDesc: [true],
          search: this.submittedFilter,
          countData: this.totalData,
          module: 'nfc-trx',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: 'ch',
        });
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};